/*
 * Waehrungszeichen nach rechts.
 *
 * Der Quantity-Breaks-Block und der Bundle-Deals-Abschnitt formatieren ihre
 * Preise selbst und ignorieren dabei die Waehrungsformatierung aus den
 * Shopify-Einstellungen - sie schreiben also "€59,99", obwohl im Shop
 * "59,99 €" eingestellt ist. Die zugehoerigen Dateien sind 123 KB bzw. 63 KB
 * gross und enthalten die Kauflogik, deshalb werden sie nicht umgeschrieben.
 * Stattdessen wird hier nachtraeglich korrigiert.
 *
 * Gearbeitet wird auf Textknoten statt auf Elementen, weil die Preise in
 * verschachteltem HTML stecken.
 *
 * Schalter: Block "Quantity Breaks: Stil" -> "Waehrungszeichen rechts".
 * Er setzt --qb-currency-right auf 1 oder 0.
 */
(function () {
  const SYMBOLS = '€$£¥';
  const LEADING = new RegExp('^(\\s*)([' + SYMBOLS + '])\\s*([0-9][0-9.,\\s ]*)$');
  const SCOPE = [
    '.quantity-breaks__container',
    '.quantity-breaks__card',
    '.fbt',
    '.qb-total',
    '.qb-row-price',
    '.bundle-deals__summary',
    '.bundle-deals__checkout-button',
    '.bundle-product-card',
  ].join(', ');

  /*
   * Der Schalter wird nur einmal gelesen. Frueher wurde er bei jeder
   * Aenderung auf der Seite neu abgefragt - das zwang den Browser jedes Mal,
   * die Stile der ganzen Seite neu zu berechnen.
   */
  let isEnabled = null;
  function enabled() {
    if (isEnabled === null) {
      const value = getComputedStyle(document.documentElement)
        .getPropertyValue('--qb-currency-right')
        .trim();
      /* Ohne den Stil-Block gilt: eingeschaltet. */
      isEnabled = value !== '0';
    }
    return isEnabled;
  }

  function fixNode(node) {
    const match = node.nodeValue && node.nodeValue.match(LEADING);
    if (!match) return;
    const amount = match[3].trim();
    node.nodeValue = match[1] + amount + ' ' + match[2];
  }

  function fixTree(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) fixNode(walker.currentNode);
  }

  function run() {
    if (!enabled()) return;
    document.querySelectorAll(SCOPE).forEach(fixTree);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /*
   * Die Bloecke rechnen Preise beim Wechsel neu - dann erneut korrigieren.
   * Nur die tatsaechlich geaenderten Stellen werden geprueft, nicht mehr
   * jedes Mal alle Preisbereiche der Seite.
   */
  const queue = new Set();
  let pending = false;

  function inScope(node) {
    const el = node.nodeType === 1 ? node : node.parentElement;
    return !!(el && el.closest(SCOPE));
  }

  function flush() {
    pending = false;
    if (!enabled()) {
      queue.clear();
      return;
    }
    queue.forEach(function (node) {
      if (!node.isConnected) return;
      if (node.nodeType === 3) {
        if (inScope(node)) fixNode(node);
      } else if (inScope(node)) {
        fixTree(node);
      } else if (node.querySelectorAll) {
        node.querySelectorAll(SCOPE).forEach(fixTree);
      }
    });
    queue.clear();
  }

  new MutationObserver(function (records) {
    for (const record of records) {
      if (record.type === 'characterData') {
        queue.add(record.target);
      } else {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 || node.nodeType === 3) queue.add(node);
        });
      }
    }
    if (queue.size && !pending) {
      pending = true;
      requestAnimationFrame(flush);
    }
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
